module.exports = __webpack_public_path__ + "static/media/diaphragm.223272f4.svg";